import { 
  Server, Shield, Users, CheckCircle 
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const expertiseIcons: LucideIcon[] = [
  Server,
  Shield,
  Users,
  CheckCircle
];